import cx from 'classnames'
import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import LocalisedTime from 'components/common/LocalisedTime'
import moment from 'moment'
import {useCallback} from 'react'
import {formatAvailabilityId} from 'utils/formatAvailabilityId'
import {ga4} from 'utils/ga4'
import {StepDataProvider} from '../../../../providers/StepDataProvider/StepDataProvider'

export const MaximizedAvailability = () => {
  const dataManager = StepDataProvider.useAvailabilityDataManager()
  const product = VentrataDataProvider.useProduct('optional')
  const availabilities = VentrataDataProvider.useAvailabilities('optional')
  const optionId = InputProvider.useOptionId('optional')
  const optionAvailabilities = availabilities[optionId]

  const onAvailabilitySelect = useCallback(
    (availabilityId: string) => {
      dataManager.save(availabilityId)

      ga4({
        event: 'select_time',
        label: moment(formatAvailabilityId(availabilityId)).format('HH:mm'),
        item_id: product.id,
        item_name: product.title,
        checkout_type: 'custom_checkout',
      })
    },
    [product, dataManager]
  )

  if (!optionAvailabilities) {
    return null
  }

  const availableAvailabilities = optionAvailabilities.filter((availability) => availability.available)

  return (
    <div className="flex gap-4 flex-wrap">
      {availableAvailabilities.map((availability) => {
        if (!availability.available) {
          return (
            <div key={availability.id} className="px-4 py-2 border-solid border rounded border-gray-4 text-gray-1">
              <LocalisedTime date={formatAvailabilityId(availability.id)} />
            </div>
          )
        }

        return (
          <div
            key={availability.id}
            className={cx(
              'flex justify-center py-2 border-solid border rounded min-w-[75px] w-[75px]',
              availability.id === dataManager.getData()
                ? 'bg-theme border-theme text-white font-semibold'
                : 'cursor-pointer border-gray-3 hover:opacity-80'
            )}
            onClick={() => onAvailabilitySelect(availability.id)}
          >
            <LocalisedTime date={formatAvailabilityId(availability.id)} />
          </div>
        )
      })}
    </div>
  )
}
